/* global define */

window._define('modules/pm-list', ['jquery', 'app/core', 'modules/confirm', 'common/commands', 'common/pubsub'], function ($, core, confirm, commands, pubsub) { 'use strict';
    var lang = $('html').attr('lang');

    commands.execute('registerAnchor', [
        '\/new',
        function () {
            $(function () {
                pubsub.publish('thread.post.action', { action: 'new' });
            });
        }
    ]);

    function updateActions($element, selectedAmount) {
        var btText, alertText;

        if (lang === 'fr') {
            btText = (selectedAmount === 1) ? 'Supprimer ce message' : 'Supprimer {0} messages';
            alertText = (selectedAmount === 1) ? 'Êtes-vous sûr de vouloir supprimer ce message privé&nbsp;?' : 'Êtes-vous sûr de vouloir supprimer ces {0}&nbsp;messages privés&nbsp;?';
        } else {
            btText = (selectedAmount === 1) ? 'Delete this message' : 'Delete {0} messages';
            alertText = (selectedAmount === 1) ? 'Are you sure you want to delete this message?' : 'Are you sure you want to delete those {0}&nbsp;messages?';
        }

        $element.toggleClass('pm-actions--can-delete', !!selectedAmount);

        $('.js-pm-actions-delete-txt').text(core.string.format(btText, selectedAmount));
        $('.js-confirm-pm-delete').data('message', core.string.format(alertText, selectedAmount));
    }

    $(function () {

        var $actions = $('.js-pm-actions'),
            $listMessage = $('.js-list-msg');

        $listMessage.messageList({
            select: function (event, data) {
                updateActions($actions, data.amount);
            }
        });

        $('.js-confirm-pm-delete').on('click', function () {
            confirm.show({
                element: this,
                confirmCallback: function () {
                    $listMessage.closest('form').submit();
                }
            });
        });

    });

});
